<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Entreprises</h1>
                    <p>Gestion des sociétés</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.company.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer une entreprise</span>
                </li>
                <!--
                <li v-if="$aclInterfaceValidator('weeboxcore.company.export')">
                  <icon name="download-cloud-01"/>
                  <span @click="exportFile('categories')">Export les résultats (Excel)</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxcore.company.import')">
                  <icon name="download-cloud-01"/>
                  <span @click="importFile()">Importer</span>
                </li>
                -->
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" active-tabs="true" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="center"><span>Geste commercial</span></div>
                        <div class="center"><span>Collaborateurs</span></div>
                        <div><span>Scope</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)">
                        <div></div>
                        <div class="picture no-radius">
                            <figure>
                                <icon name="building-05" v-if="!item.picture"/>
                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                        <div data-field="name"><strong class="highlight">{{ item.name }}</strong></div>
                        <div class="center">
                          <span v-if="item.commercial_gesture">{{ item.commercial_gesture.name }}</span>
                          <span v-else>-</span>
                        </div>
                        <div class="center"><i class="icon icon-icon_users"></i> {{ item.persons.length }}</div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul>
                                <li v-if="item.policies && item.policies.delete"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="item.policies && item.policies.update"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import CompanyService from './CompanyService.js';
    import Index from '../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return CompanyService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/Index.vue